// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"2219359c","258":"b5d1b57c","377":"ae15363d","417":"35815cf6","467":"28fb8b0b","626":"e5e40771","870":"a39741e5"}[chunkId] + ".js";
};